import React from 'react';

import { Grid, Typography, makeStyles, useTheme } from '@material-ui/core';
import AutoCard from 'components/AutoCard';
import FilterSelector from 'components/FilterSelector';
import i18n from 'i18n';
import { PeriodCountAccess } from 'modules/dashboard/interfaces';
import {
  getEnvironmentsCostMonitorGraphRequest,
  setPeriodFilterEnvironmentsCost,
} from 'modules/monitor/actions';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import { filterPeriodOptions } from 'utils/graphs';
import { EnvironmentsCostGraphFields } from 'modules/monitor/interfaces';
import { formatCurrency } from 'utils/helpers';
import EnvironmentCardGraphContent from './EnvironmentsCostGraphContent';
import styles, { overrideCardGraph, overrideFilter } from './styles';

interface EnvironmentsCostCardProps {
  environmentsCostGraphFields: EnvironmentsCostGraphFields;
  intervalTime: PeriodCountAccess;
  setPeriodFilterEnvironmentsCost: (prop: string) => void;
  getEnvironmentsCostMonitorGraphRequest: ({ intervalTime }) => void;
}

const EnvironmentsCostCard = ({
  environmentsCostGraphFields,
  intervalTime,
  setPeriodFilterEnvironmentsCost,
  getEnvironmentsCostMonitorGraphRequest,
}: EnvironmentsCostCardProps) => {
  const useStyles = makeStyles(styles);
  const classes = useStyles({});
  const { breakpoints } = useTheme();

  React.useEffect(() => {
    getEnvironmentsCostMonitorGraphRequest({
      intervalTime,
    });
  }, [getEnvironmentsCostMonitorGraphRequest, intervalTime]);

  return (
    <Grid item className={classes.environmentsCostContainer}>
      <Grid item>
        <Grid container alignItems="center" justify="space-between">
          <Grid item>
            <Typography className={classes.titleCard}>
              {i18n.t('COSTS_PAGE.ENVIRONMENTS_COST_TITLE_KEY')}
              {': '}
              {formatCurrency(environmentsCostGraphFields?.total)}
            </Typography>
          </Grid>
          <Grid item>
            <FilterSelector
              overrideClasses={overrideFilter}
              options={filterPeriodOptions(setPeriodFilterEnvironmentsCost)}
              currentValue={{
                label: i18n.t(
                  `ENVIRONMENT_DASHBOARD.LAST_${intervalTime.toUpperCase()}`
                ),
                onClick: () => null,
              }}
            />
          </Grid>
        </Grid>
      </Grid>
      <AutoCard overrideClasses={overrideCardGraph(breakpoints)}>
        <Grid container className={classes.containerGraph}>
          <EnvironmentCardGraphContent />
        </Grid>
      </AutoCard>
    </Grid>
  );
};

const mapStateToProps = ({
  monitor: { environmentsCostGraphFields, periodFilterEnvironmentsCost },
}: ApplicationState) => ({
  environmentsCostGraphFields,
  intervalTime: periodFilterEnvironmentsCost,
});

export default connect(mapStateToProps, {
  setPeriodFilterEnvironmentsCost,
  getEnvironmentsCostMonitorGraphRequest,
})(EnvironmentsCostCard);
